import(/* webpackMode: "eager" */ "/home/runner/work/examanet/examanet/src/app/error.tsx");
